import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import {
  EdgeTransactionDirection,
  EdgeTransactionRecord,
  EdgeTransactionStatus
} from '@models/edge/edge-transaction-record';
import { CommonOffcanvasComponent } from '@shared/components/commons/common-offcanvas/common-offcanvas.component';
import { downloadBase64File } from '@shared/utils/download-base64-file';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { SuperuserApiService } from '../../../../services/superuser-api.service';

@Component({
  selector: 'app-edge-transaction-details',
  standalone: true,
  imports: [
    CommonOffcanvasComponent,
    DatePipe,
  ],
  templateUrl: 'edge-transaction-details.component.html',
  styleUrls: ['edge-transaction-details.component.scss']
})
export class EdgeTransactionDetailsComponent extends CommonOffcanvasComponent {
  superuserService = inject(SuperuserApiService);
  toastr = inject(ToastrService);

  @Input({
    alias: 'transactionRecord',
    required: true
  }) set transactionRecordSetter(record: EdgeTransactionRecord | null) {
    this.transactionRecord = record;
    this.transactionText = null;

    if (record) {
      this.loadTransactionText(record);
    }
  }

  @Output() refreshData = new EventEmitter<void>();

  readonly EdgeTransactionStatus = EdgeTransactionStatus;
  readonly EdgeTransactionDirection = EdgeTransactionDirection;

  isModelLoading = signal(false);
  isActionLoading = signal(false);

  transactionRecord: EdgeTransactionRecord | null = null;
  transactionText: string | null = null;

  loadTransactionText(record: EdgeTransactionRecord): void {
    this.isModelLoading.set(true);
    this.transactionText = record.transactionText;
  }

  downloadTransaction() {
    if (!this.transactionRecord) {
      return;
    }

    this.isActionLoading.set(true);
    this.superuserService.downloadTransaction(this.transactionRecord.transactionId)
      .subscribe({
        next: (data) => {
          this.isActionLoading.set(false);
          downloadBase64File(data, `T${ this.transactionRecord?.transactionId }.txt`);
        },
        error: (error: HttpErrorResponse) => {
          console.error(error);
          this.toastr.error(`Download error`, "Error");
          return of('ERR');
        }
      });
  }

  reprocessTransaction() {
    if (!this.transactionRecord) {
      return;
    }

    this.isActionLoading.set(true);
    this.superuserService.reprocessTransaction(this.transactionRecord.transactionId)
      .subscribe({
        next: () => {
          this.isActionLoading.set(false);
          this.toastr.success('Transaction scheduled for reprocessing', 'Success');
        },
        error: (error) => {
          this.isActionLoading.set(false);
          console.error(error);
          this.toastr.error('Failed to reprocess transaction', 'Error');
        },
      });
  }
}
